module.exports = __webpack_public_path__ + "img/bg.1631f40c.png";